/**
 * Logger utility that can be controlled via environment variables
 * 
 * Configuration:
 * - VITE_ENABLE_LOGGING: 'true' to enable all logs, 'false' to disable all logs
 * - In production mode, only errors are logged by default
 * - In development mode, all logs are enabled by default
 */

const isDevelopment = import.meta.env.DEV || import.meta.env.MODE === 'development';
const isProduction = import.meta.env.PROD || import.meta.env.MODE === 'production';
const enableLoggingEnv = import.meta.env.VITE_ENABLE_LOGGING;

// In production: only errors are logged unless explicitly enabled
// In development: all logs are enabled unless explicitly disabled
const enableAllLogs = enableLoggingEnv === 'true' || 
                     (enableLoggingEnv !== 'false' && isDevelopment);

// Errors are always logged in production (for debugging critical issues)
const enableErrorLogs = isProduction || enableAllLogs;

export const logger = {
  log: (...args: any[]) => {
    if (enableAllLogs) {
      console.log(...args);
    }
  },
  info: (...args: any[]) => {
    if (enableAllLogs) {
      console.info(...args);
    }
  },
  warn: (...args: any[]) => {
    if (enableAllLogs) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    // Errors are always logged in production for critical debugging
    if (enableErrorLogs) {
      console.error(...args);
    }
  },
  debug: (...args: any[]) => {
    if (enableAllLogs) {
      console.debug(...args);
    }
  },
  group: (...args: any[]) => {
    if (enableAllLogs) {
      console.group(...args);
    }
  },
  groupEnd: () => {
    if (enableAllLogs) {
      console.groupEnd();
    }
  },
};

